import React, { useEffect, useState } from "react";

import Card from "./Card";
import useTimer from "./useTimer";
import copy from "copy-text-to-clipboard";

import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

const Grid = (props) => {
   const {
      list,
      visibleItems,
      finishedItems,
      winner,
      newGame,
      checkItems,
      setNewGame,
      setWinner,
      setVisibleItems,
      setFinishedItems,
   } = props;

   const { timer, handleStart, handlePause, handleReset } = useTimer();

   const [clicks, setclicks] = useState(0);

   const count = () => {
      let steps = clicks;
      steps++;
      setclicks(steps);

      steps === 1 && handleStart();
   };

   useEffect(() => {
      if (finishedItems.length > 0 && finishedItems.length === list.length) {
         handlePause();
      }
   }, [finishedItems]);

   useEffect(() => {
      handleReset();
      setclicks(0);
   }, [newGame]);

   const btnNewGame = () => {
      setNewGame(!newGame);
      setVisibleItems([]);
      setFinishedItems([]);
      setWinner(false);
   };

   const swalConfirmed = Swal.mixin({
      showConfirmButton: false,
      timer: 1000,
   });

   const modalWinner = (timer, discount, code, message) => {
      Swal.fire({
         title: message,
         text: "Terminaste en " + timer + " segundos y gánaste " + discount + " en tu próxima compra con el cupón:",
         customClass: "mySwall",
         input: "text",
         inputValue: code,
         inputAttributes: {disabled: true,},
         padding: "1em",
         color: "#333333",
         font: '"Roboto", sans-serif;',
         backdrop: "rgb(0 0 0 / 69%)",
         showDenyButton: true,
         showCloseButton: true,
         confirmButtonText: "Copiar Código",
         confirmButtonColor: "#333333",
         denyButtonColor: "#ffffff",
         denyButtonText: "VOLVER A JUGAR",
         didDestroy: () => {
            btnNewGame();
            copy(code);
         },
      }).then((result) => {
         console.log(result);
         if (result.isConfirmed) {
            swalConfirmed.fire("Código copiado ✂✅", "", "");
         } else if (result.isDenied) {
            swalConfirmed.fire("Mucha suerte 🌊🦀", "", "");
         } else {
            swalConfirmed.fire("Mucha suerte 🌊🦀", "", "");
         }
      });
   };

   let discount = "";
   let code = "";
   let message = "";

   return (
      <div className='game-container'>
         <div className='x-row'>
            {list.map((item, index) => (
               <Card
                  key={item.id}
                  className={`col-3 game-card ${
                     visibleItems.includes(index) ? "grid-card-show" : ""
                  } ${
                     finishedItems.includes(index)
                        ? "grid-card-show grid-card-finished"
                        : ""
                  }`}
                  onClick={() => {
                     count();
                     if (!finishedItems.includes(index)) {
                        switch (visibleItems.length) {
                           case 0:
                              setVisibleItems([index]);
                              break;
                           case 1:
                              if (visibleItems[0] !== index) {
                                 setVisibleItems(visibleItems.concat(index));
                                 checkItems(visibleItems[0], index);
                              }
                              break;
                           case 2:
                              setVisibleItems([index]);
                              break;
                           default:
                              setVisibleItems([]);
                        }
                     }
                  }}
                  imgSource={item.url}
                  imgDesc={item.description}
               />
            ))}

            {/* Condición de los Cupones */}
            {winner && (
                  timer <= 20 ? modalWinner(
                     timer,
                     (discount = "10% EXTRA"),
                     (code = "BOB10M"),
                     (message = "¡Eres el campeón del Fondo de Bikini! 🧽🏆"),
                  ) : timer < 26 ? modalWinner(
                     timer,
                     (discount = "ENVÍO GRATIS"),
                     (code = "FREESBIK"),
                     (message = "Has ganado 🐚 porque completaste el reto a toda velocidad. ¡Tus nuevas prendas viajarán directito desde Fondo de Bikini!"),
                  ) : modalWinner(
                     timer,
                     (discount = "5% EXTRA"),
                     (code = "GARY5P"),
                     (message = "Has ganado 🌊 porque, aunque el tiempo se alargó, Bob Esponja sabe que la práctica hace al maestro.")
                  )
               )
            }
         </div>
      </div>
   );
};

Grid.defaultProps = {
   list: [],
};

export default Grid;
